import { Observable } from 'rxjs';
import { ApiUrl } from '../api-core/api-constants';
import { apiGet } from '../api-core/api-request';
import apiResourceHookFactory from '../api-core/utility-factories/api-resource-hook-factory';
import { apiRedux } from '../api-redux';
import { RepairStats } from './api-stats.types';

// eslint-disable-next-line import/prefer-default-export
export const useRepairStats = apiResourceHookFactory(
  apiRedux.repairStats,
  (): Observable<RepairStats> => apiGet(ApiUrl.REPAIR_STATS)
);
